import { MediaModel } from '@/types/B2CcontentServerContract';
import { ref } from 'vue';

const logo = ref<MediaModel | null>(null);

export default function useCO2EmissionsLogo() {
    function setLogo(newLogo: MediaModel) {
        logo.value = newLogo;
    }

    return {
        logo,
        setLogo,
    };
}
